import { USER_PERMISSIONS } from 'dyl-components';
import CustomerPipelines from 'pages/Pipeline/CustomerPipelines';
import LeadPipelines from 'pages/Pipeline/LeadPipelines' 
import OpportunityPipelines from 'pages/Pipeline/OpportunityPipelines';

import React from 'react';
import { Route } from 'react-router-dom';
import RestrictedView from 'shared/RestrictedView';

export const PIPELINE_ROUTES = [
    <Route path='lead-pipelines' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.PIPELINE_VIEW}><LeadPipelines /></RestrictedView> } />,
    <Route path='customer-pipelines' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.PIPELINE_VIEW}><CustomerPipelines /></RestrictedView>} />,
    <Route path='opportunity-pipelines' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.PIPELINE_VIEW}><OpportunityPipelines /></RestrictedView>} />,
];
